import { z } from 'zod'
import * as http from '@/util/http'

export const InterestSchema = z.object({
  id: z.number().int(),
  name: z.string(),
  emoji: z.string().optional(),
})

export type Interest = z.infer<typeof InterestSchema>

export async function fetchUserInterests(): Promise<Interest[]> {
  const { data } = await http.get<Interest[]>('/api/v1/user/profile/interest')
  return data
}
